/* Big Z: soft Add to Cart (AJAX) for tile + slide ATC buttons */
(function () {
  if (window.bzCartAdd) return;

  // Internal request batching only. This is not the customer/order quantity cap;
  // Shopify's Admin > Checkout > Add-to-cart limit controls that storefront cap.
  // Keep this at the common default cap so a 55+ add can become 50 + remainder
  // instead of one rejected request.
  var CART_ADD_REQUEST_BATCH_SIZE = 50;
  var CART_ADD_BUSY_RETRIES = 2;
  var learnedCartLimitsByVariant = Object.create(null);

  // Defensive JSON parse for /cart/*.js responses. The Shopify CLI dev server's
  // hot-reload proxy sometimes returns an empty body (304) when a request carries
  // `sections=...` and the section was unchanged — calling r.json() on that throws
  // "Unexpected end of JSON input" and we'd surface a bogus add-to-cart failure to
  // the user. Treat OK+empty as success-with-no-payload; only throw on real errors.
  function safeJson(r) {
    return r.text().then(function (text) {
      var data = null;
      if (text) { try { data = JSON.parse(text); } catch (e) { data = null; } }
      if (!r.ok) {
        var fallback = cartErrorMessage(r.status, text);
        var msg = r.status === 409 ? fallback : ((data && (data.description || data.message)) || fallback);
        var err = new Error(msg);
        err.status = r.status;
        err.data = data;
        if (r.status === 409) err.cartBusy = true;
        throw err;
      }
      return data || {};
    });
  }

  function cartErrorMessage(status, text) {
    if (status === 429 && /verifying your connection/i.test(text || '')) {
      return 'Local preview cart blocked - use preview link.';
    }
    if (status === 409) return 'Cart is busy - try again.';
    if (status === 429) return 'Cart is busy - try again in a minute.';
    if (status >= 500) return 'Cart connection issue - try again.';
    if (status === 404) return 'Cart endpoint not found.';
    return 'Could not update cart.';
  }

  // 2026-10-04 speed (pass 12): the last cart this page was told about (any cart:update that
  // carried the cart). A size pick re-reads /cart.js to cap the quantity; it used to broadcast
  // cart:update every time, so every pick re-rendered the cart drawer (~90 DOM changes plus a
  // full-page style pass) and sent the lot engine for another /cart.js. Now it only broadcasts
  // when the cart really differs from what the page last heard (e.g. changed in another tab).
  // 2026-10-25: an empty cart at page load is known up front (snippets/bz-ride-along sets BZRideCfg),
  // so the first size pick on an empty-cart page no longer broadcasts.
  var lastCartSig = (window.BZRideCfg && window.BZRideCfg.itemCount === 0) ? '0|0|' : null;
  function cartSig(cart) {
    if (!cart || !cart.items) return null;
    var lines = [];
    for (var i = 0; i < cart.items.length; i++) lines.push((cart.items[i].key || cart.items[i].id) + 'x' + cart.items[i].quantity);
    return cart.item_count + '|' + cart.total_price + '|' + lines.join(',');
  }

  function dispatchCartUpdate(cart, sourceId, extra) {
    var itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 0;
    var data = Object.assign(
      { source: 'bz-tile-add', itemCount: itemCount },
      extra || {}
    );
    if (typeof data.itemCount !== 'number') data.itemCount = itemCount;
    var detail = {
      resource: cart,
      sourceId: sourceId || '',
      data: data,
    };
    document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: detail }));
  }

  function updateBubbleCounts(count) {
    // Broad fallback so the cart bubble in the header reflects the latest count
    // even if the standard cart-icon listener missed our event (e.g. when added
    // from a quick-add tile on collection / search / product pages).
    var bubbles = document.querySelectorAll('.cart-bubble');
    for (var b = 0; b < bubbles.length; b++) {
      bubbles[b].classList.toggle('visually-hidden', count === 0);
      var countEl = bubbles[b].querySelector('.cart-bubble__text-count');
      if (countEl) {
        countEl.textContent = count > 0 && count < 100 ? String(count) : (count >= 100 ? '' : '');
        countEl.classList.toggle('hidden', count === 0);
      }
    }
    var icons = document.querySelectorAll('cart-icon');
    for (var ic = 0; ic < icons.length; ic++) {
      icons[ic].classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    }
    var legacy = document.querySelectorAll('[data-cart-count]');
    for (var l = 0; l < legacy.length; l++) {
      legacy[l].setAttribute('data-cart-count', String(count));
      legacy[l].textContent = count > 99 ? '99+' : String(count);
      if ('hidden' in legacy[l]) legacy[l].hidden = count === 0;
    }
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(safeJson);
  }

  function cartQuantityForVariant(cart, variantId) {
    var target = parseInt(variantId, 10);
    if (!target || !cart || !cart.items) return 0;
    var total = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var itemId = parseInt(cart.items[i].variant_id || cart.items[i].id, 10);
      if (itemId === target) total += parseInt(cart.items[i].quantity, 10) || 0;
    }
    return total;
  }

  function variantKey(variantId) {
    var id = parseInt(variantId, 10);
    return id ? String(id) : '';
  }

  function itemVariantId(item) {
    return parseInt(item && (item.id || item.variant_id), 10) || 0;
  }

  function itemQuantity(item) {
    var quantity = parseInt(item && item.quantity, 10);
    return quantity && quantity > 0 ? quantity : 1;
  }

  function rememberVariantCartLimit(variantId, limit) {
    var key = variantKey(variantId);
    var value = parseInt(limit, 10);
    if (!key || isNaN(value) || value < 0) return;
    learnedCartLimitsByVariant[key] = value;
  }

  function cartLimitForVariant(variantId) {
    var key = variantKey(variantId);
    if (!key || !Object.prototype.hasOwnProperty.call(learnedCartLimitsByVariant, key)) return null;
    return learnedCartLimitsByVariant[key];
  }

  function cartLimitErrorText(err) {
    var parts = [];
    if (err && err.message) parts.push(err.message);
    if (err && err.data) {
      if (err.data.description) parts.push(err.data.description);
      if (err.data.message) parts.push(err.data.message);
    }
    return parts.join(' ');
  }

  function isCartLimitError(err) {
    return /maximum quantity|maximum.*cart|already.*cart|in your cart|cart limit|add-to-cart limit|quantity limit|can't add more|cannot add more/i.test(cartLimitErrorText(err));
  }

  function rememberCartLimitsFromError(err, cart, fallbackVariantId) {
    if (!isCartLimitError(err) || !cart || !cart.items) return;
    var seen = Object.create(null);
    if (err.addedQuantitiesByVariant) {
      for (var key in err.addedQuantitiesByVariant) {
        if (!Object.prototype.hasOwnProperty.call(err.addedQuantitiesByVariant, key)) continue;
        var qty = cartQuantityForVariant(cart, key);
        if (qty > 0) {
          rememberVariantCartLimit(key, qty);
          seen[key] = true;
        }
      }
    }
    var fallbackKey = variantKey(fallbackVariantId);
    if (fallbackKey && !seen[fallbackKey]) {
      var fallbackQty = cartQuantityForVariant(cart, fallbackKey);
      if (fallbackQty > 0) rememberVariantCartLimit(fallbackKey, fallbackQty);
    }
  }

  function recordAddedQuantities(target, items) {
    var total = 0;
    for (var i = 0; i < (items || []).length; i++) {
      var id = itemVariantId(items[i]);
      var quantity = itemQuantity(items[i]);
      if (id) {
        var key = String(id);
        target[key] = (target[key] || 0) + quantity;
      }
      total += quantity;
    }
    return total;
  }

  function cartAddErrorMessage(err) {
    if (err && err.partialCartAdd && err.addedQuantity > 0 && isCartLimitError(err)) {
      return 'Added ' + err.addedQuantity + '. Cart limit reached for this item.';
    }
    if (err && isCartLimitError(err)) return 'Cart limit reached for this item.';
    return (err && err.message) || 'Try again';
  }

  function fetchCartCount() {
    return fetchCart()
      .then(function (cart) {
        updateBubbleCounts(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
        return cart;
      })
      .catch(function () { /* ignore */ });
  }

  // The cart right after an add: the one the inventory guard read straight after the write when it
  // has it (2026-10-25 speed: saves a /cart.js round trip), otherwise a fresh read.
  function cartAfterAdd(response) {
    var checked = response && response.__bzCart;
    if (checked && typeof checked.item_count === 'number') {
      updateBubbleCounts(checked.item_count);
      return Promise.resolve(checked);
    }
    var pending = response && response.__bzChecked;
    if (pending && typeof pending.then === 'function') {
      return pending.then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          updateBubbleCounts(cart.item_count);
          return cart;
        }
        return fetchCartCount();
      }, function () { return fetchCartCount(); });
    }
    return fetchCartCount();
  }

  // Optimistic count for the header bubble while the checked cart is on its way (it corrects it).
  function bumpBubble(items) {
    var n = 0;
    for (var i = 0; i < (items || []).length; i++) n += parseInt(items[i] && items[i].quantity, 10) || 0;
    var el = document.querySelector('.cart-bubble__text-count');
    var current = el ? parseInt(el.textContent, 10) : NaN;
    if (n > 0 && !isNaN(current)) updateBubbleCounts(current + n);
  }

  function clearCartDiscounts() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: '' })
    }).then(safeJson);
  }

  function showInventoryFeedback(sourceElement, message) {
    if (!message || !window.bzInventoryGuard) return;
    if (typeof window.bzInventoryGuard.showInlineError === 'function') {
      window.bzInventoryGuard.showInlineError(sourceElement, message);
    }
    if (typeof window.bzInventoryGuard.showToast === 'function') {
      window.bzInventoryGuard.showToast(message);
    }
  }

  // 2026-10-25 speed: the button says "Adding..." the moment it is tapped (it used to sit unchanged,
  // just dimmed, for the whole round trip).
  var ADDING = 'Adding…';
  function showAdding(btn) {
    btn._bzBeforeAdding = btn.innerHTML;
    btn.setAttribute('aria-busy', 'true');
    btn.innerHTML = '<span class="bz-tile__add-label">' + ADDING + '</span>';
  }

  function endAdding(btn) {
    var before = btn._bzBeforeAdding;
    btn._bzBeforeAdding = null;
    btn.removeAttribute('aria-busy');
    return before;
  }

  function flash(btn, text) {
    var before = endAdding(btn);
    var current = btn.innerHTML;
    // Return to the label the button should show now: a fresh one if the cart sync already
    // re-rendered it, otherwise what it said before "Adding...".
    var prev = btn.getAttribute('data-prev-html') ||
      (before != null && current.indexOf(ADDING) !== -1 ? before : current);
    btn.setAttribute('data-prev-html', prev);
    btn.innerHTML = text;
    btn.classList.add('is-flashed');
    var token = (btn._bzFlashToken || 0) + 1;
    btn._bzFlashToken = token;
    setTimeout(function () {
      if (btn._bzFlashToken !== token) return;
      // A label refreshed during the flash was parked in data-prev-html (renderLockedToggle).
      btn.innerHTML = btn.getAttribute('data-prev-html') || prev;
      // Forget it, so the next add returns to that moment's label, not this one's.
      btn.removeAttribute('data-prev-html');
      btn.classList.remove('is-flashed');
    }, 1800);
  }

  function readQty(btn) {
    var picker = btn.closest('[data-bz-variant-picker]');
    if (!picker) return 1;
    var input = picker.querySelector('[data-bz-tile-qty-input]');
    if (!input) return 1;
    var v = parseInt(input.value, 10);
    if (!v || v < 1) v = 1;
    var max = parseInt(input.getAttribute('max'), 10);
    if (!isNaN(max) && v > max) v = max;
    return v;
  }

  function buttonHandle(btn) {
    if (!btn) return '';
    return btn.getAttribute('data-bz-product-handle') ||
      btn.getAttribute('data-product-handle') ||
      (btn.closest && btn.closest('[data-bz-product-handle]') && btn.closest('[data-bz-product-handle]').getAttribute('data-bz-product-handle')) ||
      '';
  }

  function guardItems(items, sourceElement) {
    if (window.bzInventoryGuard && typeof window.bzInventoryGuard.clampAddItems === 'function') {
      return window.bzInventoryGuard.clampAddItems(items, {
        sourceElement: sourceElement,
        deferFeedback: true,
        preserveHandles: true
      });
    }
    return Promise.resolve({ items: items, warnings: [] });
  }

  function cloneItemWithQuantity(item, quantity) {
    var clone = {};
    for (var key in item) {
      if (Object.prototype.hasOwnProperty.call(item, key)) clone[key] = item[key];
    }
    clone.quantity = quantity;
    return clone;
  }

  function chunkAddItems(items) {
    var chunks = [];
    var chunk = [];
    var chunkQty = 0;

    function flush() {
      if (!chunk.length) return;
      chunks.push(chunk);
      chunk = [];
      chunkQty = 0;
    }

    for (var i = 0; i < (items || []).length; i++) {
      var item = items[i];
      if (!item) continue;
      var remaining = parseInt(item.quantity, 10);
      if (!remaining || remaining < 1) remaining = 1;

      while (remaining > 0) {
        var room = CART_ADD_REQUEST_BATCH_SIZE - chunkQty;
        if (room <= 0) {
          flush();
          room = CART_ADD_REQUEST_BATCH_SIZE;
        }
        var take = Math.min(remaining, room);
        chunk.push(cloneItemWithQuantity(item, take));
        chunkQty += take;
        remaining -= take;
        if (chunkQty >= CART_ADD_REQUEST_BATCH_SIZE) flush();
      }
    }

    flush();
    return chunks;
  }

  function postCartAdd(items) {
    // Keep the add request focused on the cart mutation only. Asking Shopify to
    // render cart sections in the same /cart/add.js response makes a section
    // Liquid/rendering failure surface as "Could not add (5xx)" even when the
    // variant and quantity are valid. We refresh the drawer/icon separately via
    // cart:update after the canonical cart is fetched.
    //
    // 2026-10-25 speed: these items already went through the inventory guard (guardItems), so the
    // guard's fetch hook skips a second clamp, and stays quiet (we broadcast cart:update once, below,
    // with the checked cart it hands back). It still queues the write and repairs after it.
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items: items }),
      bzInventoryGuarded: !!window.bzInventoryGuard,
      bzQuiet: true
    }).then(withCheckedCart);
  }

  // Keep the guard's checked cart (response.bzCart) on the parsed payload for cartAfterAdd().
  function withCheckedCart(r) {
    var checked = r && r.bzCart;
    var pending = r && r.bzChecked;
    return safeJson(r).then(function (data) {
      if (data && typeof data === 'object') {
        try {
          if (checked) Object.defineProperty(data, '__bzCart', { value: checked, enumerable: false });
          if (pending) Object.defineProperty(data, '__bzChecked', { value: pending, enumerable: false });
        } catch (e) { /* ignore */ }
      }
      return data;
    });
  }

  function shouldRetryCartAdd(err) {
    return err && (err.status === 409 || err.status === 429 || err.status >= 500);
  }

  function shouldFallbackNativeCartAdd(err) {
    return err && (err.status === 429 || err.status >= 500);
  }

  function wait(ms) {
    return new Promise(function (resolve) { setTimeout(resolve, ms); });
  }

  function withCartAddRetries(task, retries) {
    var attempt = 0;
    function run() {
      return task().catch(function (err) {
        if (!err || err.status !== 409 || attempt >= retries) throw err;
        attempt += 1;
        return wait(180 * attempt).then(run);
      });
    }
    return run();
  }

  function itemToFormData(item) {
    var formData = new FormData();
    formData.append('id', item.id);
    formData.append('quantity', item.quantity || 1);
    if (item.selling_plan) formData.append('selling_plan', item.selling_plan);
    if (item.handle || item.productHandle || item.product_handle) {
      formData.append('product_handle', item.handle || item.productHandle || item.product_handle);
    }
    if (item.properties && typeof item.properties === 'object') {
      for (var key in item.properties) {
        if (Object.prototype.hasOwnProperty.call(item.properties, key) && item.properties[key] != null) {
          formData.append('properties[' + key + ']', item.properties[key]);
        }
      }
    }
    return formData;
  }

  function postCartAddForm(item) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: itemToFormData(item)
    }).then(safeJson);
  }

  function submitNativeCartAdd(item) {
    if (!item || !item.id || !document.body) return false;
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.style.display = 'none';

    function field(name, value) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    }

    field('id', item.id);
    field('quantity', item.quantity || 1);
    field('return_to', '/cart');
    if (item.selling_plan) field('selling_plan', item.selling_plan);
    if (item.properties && typeof item.properties === 'object') {
      for (var key in item.properties) {
        if (Object.prototype.hasOwnProperty.call(item.properties, key) && item.properties[key] != null) {
          field('properties[' + key + ']', item.properties[key]);
        }
      }
    }

    document.body.appendChild(form);
    form.submit();
    return true;
  }

  function postCartAddChunk(chunk) {
    return withCartAddRetries(function () { return postCartAdd(chunk); }, CART_ADD_BUSY_RETRIES).catch(function (err) {
      if (!shouldFallbackNativeCartAdd(err)) throw err;

      var lastResponse = {};
      var fallbackChain = Promise.resolve();
      for (var i = 0; i < chunk.length; i++) {
        (function (item) {
          fallbackChain = fallbackChain.then(function () {
            return withCartAddRetries(function () { return postCartAddForm(item); }, CART_ADD_BUSY_RETRIES).then(function (response) {
              lastResponse = response || {};
              return lastResponse;
            });
          });
        })(chunk[i]);
      }
      return fallbackChain.then(function () { return lastResponse; });
    });
  }

  function addToCart(items) {
    var chunks = chunkAddItems(items);
    var lastResponse = {};
    var addedQuantitiesByVariant = Object.create(null);
    var addedQuantity = 0;
    var chain = Promise.resolve();
    for (var i = 0; i < chunks.length; i++) {
      (function (chunk) {
        chain = chain.then(function () {
          return postCartAddChunk(chunk).then(function (response) {
            addedQuantity += recordAddedQuantities(addedQuantitiesByVariant, chunk);
            lastResponse = response || {};
            return lastResponse;
          });
        });
      })(chunks[i]);
    }
    return chain
      .then(function () { return lastResponse; })
      .catch(function (err) {
        if (addedQuantity > 0) {
          err.partialCartAdd = true;
          err.addedQuantity = addedQuantity;
          err.addedQuantitiesByVariant = addedQuantitiesByVariant;
        }
        throw err;
      });
  }

  function add(btn) {
    if (btn.disabled) return;
    var id = btn.getAttribute('data-bz-variant-id');
    if (!id) return;
    btn.disabled = true;
    btn.classList.add('is-loading');
    showAdding(btn);

    var items = [];
    if (btn.hasAttribute('data-bz-add-both')) {
      var productScope = btn.closest('[data-bz-product]');
      var form = productScope ? productScope.querySelector('#bz-product-form') : null;
      var currentInput = form ? form.querySelector('input[name="id"]') : null;
      var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      var currentId = currentInput ? parseInt(currentInput.value, 10) : 0;
      var currentQty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      if (!currentQty || currentQty < 1) currentQty = 1;
      if (currentId) {
        items.push({
          id: currentId,
          quantity: currentQty,
          handle: btn.getAttribute('data-bz-current-product-handle') || (productScope && productScope.getAttribute('data-bz-product-handle')) || ''
        });
      }
      items.push({
        id: parseInt(id, 10),
        quantity: 1,
        handle: btn.getAttribute('data-bz-buddy-handle') || buttonHandle(btn)
      });
    } else {
      items.push({ id: parseInt(id, 10), quantity: readQty(btn), handle: buttonHandle(btn) });
    }

    if (!btn.hasAttribute('data-bz-add-both') && items[0] && items[0].quantity < 1) {
      var maxedMessage = 'All available stock is already in your cart.';
      showInventoryFeedback(btn, maxedMessage);
      flash(btn, '⚠ ' + maxedMessage);
      btn.disabled = false;
      btn.classList.remove('is-loading');
      return;
    }

    guardItems(items, btn)
      .then(function (guarded) {
        return addToCart(guarded.items).then(function (response) {
          return { response: response, warnings: guarded.warnings, items: guarded.items };
        });
      })
      .then(function (guardedResponse) {
        var response = guardedResponse.response;
        var warnings = guardedResponse.warnings;
        // 2026-10-25 speed: "Added" the moment Shopify accepts the add. The checked cart follows
        // (header count, the card's quantity limits, one cart:update for everything else).
        if (warnings.length) showInventoryFeedback(btn, warnings[0]);
        flash(btn, '✅ Added');
        bumpBubble(guardedResponse.items);
        // The canonical cart, so item_count is correct (cart/add.js returns the line items, not the cart).
        return cartAfterAdd(response).then(function (cart) {
          if (cart) refreshTileQtyFromCart(btn, cart);
          dispatchCartUpdate(cart || {}, btn.id || '', {
            variantId: id,
            sections: response && response.sections ? response.sections : undefined,
          });
        });
      })
      .catch(function (err) {
        if (!err.partialCartAdd && items.length === 1 && shouldFallbackNativeCartAdd(err) && submitNativeCartAdd(items[0])) return;
        return fetchCart()
          .then(function (cart) {
            rememberCartLimitsFromError(err, cart, id);
            refreshTileQtyFromCart(btn, cart);
            refreshAllTileQtyFromCart(cart || {});
            if (cart && typeof cart.item_count === 'number') updateBubbleCounts(cart.item_count);
            dispatchCartUpdate(cart || {}, btn.id || '', {
              source: err.partialCartAdd ? 'bz-cart-partial-add' : 'bz-cart-add-error',
              variantId: id,
              partial: !!err.partialCartAdd
            });
            var message = cartAddErrorMessage(err);
            showInventoryFeedback(btn, message);
            flash(btn, err.partialCartAdd ? message : ('! ' + message));
          })
          .catch(function () {
            var message = cartAddErrorMessage(err);
            showInventoryFeedback(btn, message);
            flash(btn, err.partialCartAdd ? message : ('! ' + message));
          });
      })
      .finally(function () {
        btn.disabled = false;
        btn.classList.remove('is-loading');
        if (btn._bzBeforeAdding != null) {
          var before = endAdding(btn);
          if (btn.innerHTML.indexOf(ADDING) !== -1) btn.innerHTML = before;
        }
      });
  }

  // Public helper: add several line items in one atomic /cart/add.js call.
  // items: [{ id, quantity, properties? }, ...]. Returns a Promise resolving
  // to { cart, response }. `properties` is an optional object of line-item
  // properties (e.g. "Size aim", "Size note") preserved as-is.
  // opts.onAccepted(response): called the moment Shopify accepts the add, before the checked cart
  // arrives (2026-10-25, so the product page can say "Added" sooner).
  function addItems(items, opts) {
    var clean = [];
    for (var i = 0; i < (items || []).length; i++) {
      var it = items[i];
      var id = parseInt(it && it.id, 10);
      if (!id) continue;
      var q = parseInt(it.quantity, 10);
      if (it.quantity != null && it.quantity !== '' && q < 1) {
        return Promise.reject(new Error('Quantity must be at least 1.'));
      }
      if (!q) q = 1;
      var entry = { id: id, quantity: q };
      if (it.handle || it.productHandle || it.product_handle) {
        entry.handle = it.handle || it.productHandle || it.product_handle;
      }
      if (it.properties && typeof it.properties === 'object') {
        var hasKeys = false;
        for (var pk in it.properties) {
          if (it.properties.hasOwnProperty(pk) && it.properties[pk] !== '' && it.properties[pk] != null) {
            hasKeys = true; break;
          }
        }
        if (hasKeys) entry.properties = it.properties;
      }
      clean.push(entry);
    }
    if (!clean.length) return Promise.reject(new Error('Nothing to add'));

    function finishAddItems(response, source, err) {
      return (err ? fetchCartCount() : cartAfterAdd(response)).then(function (cart) {
        if (err) rememberCartLimitsFromError(err, cart, clean[0] && clean[0].id);
        refreshAllTileQtyFromCart(cart || {});
        dispatchCartUpdate(cart || {}, '', {
          source: source,
          count: clean.length,
          partial: !!(err && err.partialCartAdd),
          sections: response && response.sections ? response.sections : undefined
        });
        return { cart: cart, response: response, warning: err ? cartAddErrorMessage(err) : '' };
      });
    }

    return guardItems(clean, null).then(function (guarded) {
      return addToCart(guarded.items);
    })
      .then(function (response) {
        if (opts && typeof opts.onAccepted === 'function') {
          try { opts.onAccepted(response); } catch (e) { /* the add still finishes */ }
        }
        return finishAddItems(response, 'bz-habitat-zone', null);
      })
      .catch(function (err) {
        if (err.partialCartAdd) {
          return finishAddItems({ partial: true, error: cartAddErrorMessage(err) }, 'bz-cart-partial-add', err);
        }
        if (clean.length === 1 && shouldFallbackNativeCartAdd(err) && submitNativeCartAdd(clean[0])) {
          return new Promise(function () {});
        }
        throw err;
      });
  }

  // Public helper: empty the whole cart, then let the harness re-render the
  // cart drawer / icon / cart section via the standard cart:update event.
  function clearCart(trigger) {
    if (trigger) {
      if (trigger.dataset.bzClearing) return Promise.resolve();
      trigger.dataset.bzClearing = '1';
      trigger.disabled = true;
      trigger.classList.add('is-loading');
    }
    return fetch('/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
      .then(safeJson)
      .then(function () {
        return fetchCart().catch(function () {
          return { item_count: 0, items: [] };
        });
      })
      .then(function (cart) {
        var canonical = cart && typeof cart.item_count === 'number' ? cart : { item_count: 0, items: [] };
        updateBubbleCounts(canonical.item_count);
        dispatchCartUpdate(canonical, trigger && trigger.id ? trigger.id : '', {
          source: 'bz-cart-clear',
          itemCount: canonical.item_count
        });
        if (document.querySelector('[data-bz-cart]')) {
          setTimeout(function () { window.location.assign('/cart'); }, 50);
        }
        return canonical;
      })
      .catch(function () {
        // Fall back to a hard navigation so the user isn't stuck with a stale cart.
        window.location.href = '/cart';
      })
      .finally(function () {
        if (trigger) {
          delete trigger.dataset.bzClearing;
          trigger.disabled = false;
          trigger.classList.remove('is-loading');
        }
      });
  }

  function bindClear() {
    if (window.__bzCartClearBound) return;
    window.__bzCartClearBound = true;
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('[data-bz-cart-clear]');
      if (!btn) return;
      e.preventDefault();
      clearCart(btn);
    });
  }

  function bind(root) {
    bindClear();
    var btns = (root || document).querySelectorAll('[data-bz-add]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        if (b.dataset.bzBound) return;
        b.dataset.bzBound = '1';
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          add(b);
        });
      })(btns[i]);
    }
    bindVariantPickers(root);
  }

  function positionList(toggle, list) {
    var r = toggle.getBoundingClientRect();
    var vw = window.innerWidth || document.documentElement.clientWidth;
    // On mobile / narrow tile grids the toggle can be ~120px wide, which clips the
    // size row + stock badge. Clamp to a readable min, but never wider than viewport.
    var margin = 8;
    var minW = 240;
    var maxW = Math.max(160, vw - margin * 2);
    var width = Math.min(Math.max(r.width, minW), maxW);
    var left = r.left;
    if (left + width > vw - margin) left = vw - width - margin;
    if (left < margin) left = margin;
    list.style.position = 'fixed';
    list.style.top = (r.bottom + 6) + 'px';
    list.style.left = left + 'px';
    list.style.width = width + 'px';
    list.style.right = 'auto';
    list.style.zIndex = '9999';
  }

  function openPortal(toggle, list) {
    if (list._bzPortaled) return;
    list._bzPortaled = true;
    list._bzOriginalParent = list.parentNode;
    list._bzOriginalNext = list.nextSibling;
    list._bzToggle = toggle;
    document.body.appendChild(list);
    list.classList.add('bz-tile__variant-list--portal');
    positionList(toggle, list);

    var update = function () { positionList(toggle, list); };
    list._bzReposition = update;
    window.addEventListener('scroll', update, true);
    window.addEventListener('resize', update);
  }

  function closePortal(list) {
    if (!list._bzPortaled) return;
    list.classList.remove('bz-tile__variant-list--portal');
    list.style.position = '';
    list.style.top = '';
    list.style.left = '';
    list.style.width = '';
    list.style.right = '';
    list.style.zIndex = '';

    if (list._bzReposition) {
      window.removeEventListener('scroll', list._bzReposition, true);
      window.removeEventListener('resize', list._bzReposition);
      delete list._bzReposition;
    }
    if (list._bzOriginalParent) {
      list._bzOriginalParent.insertBefore(list, list._bzOriginalNext);
    }
    delete list._bzOriginalParent;
    delete list._bzOriginalNext;
    delete list._bzToggle;
    delete list._bzPortaled;
  }

  function closeAllPickers(except) {
    var lists = document.querySelectorAll('.bz-tile__variant-list');
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      // Inline chip rows are always visible and are not a popup. Without this guard the
      // first click anywhere on the page would blank every chip row in the grid.
      if (list.closest('[data-bz-variant-inline]')) continue;
      var pickerHost = list._bzOriginalParent || list.parentNode;
      var picker = pickerHost && pickerHost.closest && pickerHost.closest('[data-bz-variant-picker]');
      if (picker === except) continue;
      if (list._bzPortaled) closePortal(list);
      list.setAttribute('hidden', '');
      var t = picker && picker.querySelector('[data-bz-variant-toggle]');
      if (t) t.setAttribute('aria-expanded', 'false');
    }
  }

  function openPicker(picker, toggle, list) {
    closeAllPickers(picker);
    list.removeAttribute('hidden');
    toggle.setAttribute('aria-expanded', 'true');
    openPortal(toggle, list);
  }

  function closePicker(toggle, list) {
    closePortal(list);
    list.setAttribute('hidden', '');
    toggle.setAttribute('aria-expanded', 'false');
  }

  function clamp(n, min, max) {
    if (max != null && max < min) min = max;
    if (n < min) return min;
    if (max != null && n > max) return max;
    return n;
  }

  function tileQtyInfoFromInput(input) {
    return {
      variantId: input.getAttribute('data-bz-variant-id') || '',
      tracked: input.getAttribute('data-bz-tracked') === '1',
      stock: parseInt(input.getAttribute('data-bz-stock'), 10) || 0,
      canBackorder: input.getAttribute('data-bz-can-backorder') === '1'
    };
  }

  function applyTileQtyLimit(input, hint, info, cartQty) {
    var max = null;
    var min = 1;
    var label = '';
    var limitReason = '';
    cartQty = Math.max(0, parseInt(cartQty, 10) || 0);
    input.setAttribute('data-bz-cart-qty', String(cartQty));

    var learnedCartLimit = cartLimitForVariant(info.variantId);
    if (learnedCartLimit != null) {
      input.setAttribute('data-bz-cart-limit', String(learnedCartLimit));
    } else {
      input.removeAttribute('data-bz-cart-limit');
    }

    if (info.tracked && !info.canBackorder) {
      var stock = Math.max(0, parseInt(info.stock, 10) || 0);
      max = cartQty > 0 ? Math.max(0, stock - cartQty) : stock;
      limitReason = 'stock';
      if (learnedCartLimit != null) {
        var cartLimitMax = Math.max(0, learnedCartLimit - cartQty);
        if (max == null || cartLimitMax <= max) {
          max = cartLimitMax;
          limitReason = 'cart';
        }
      }
    } else if (learnedCartLimit != null) {
      max = Math.max(0, learnedCartLimit - cartQty);
      limitReason = 'cart';
    }

    if (max != null) {
      min = max === 0 ? 0 : 1;
      input.setAttribute('max', String(max));
      if (limitReason === 'cart' && max === 0) {
        label = 'Cart limit reached - ' + cartQty + ' in cart';
      } else if (cartQty > 0) {
        label = max > 0 ? 'Max ' + max + ' - ' + cartQty + ' in cart' : 'Max reached - ' + cartQty + ' in cart';
      } else {
        label = 'Max ' + max;
      }
    } else {
      input.removeAttribute('max');
    }

    input.setAttribute('min', String(min));
    var v = parseInt(input.value, 10);
    if (isNaN(v)) v = min;
    input.value = String(clamp(v, min, max));
    if (hint) hint.textContent = label;
  }

  function refreshTileQtyFromCart(toggle, cart) {
    var picker = toggle && toggle.closest ? toggle.closest('[data-bz-variant-picker]') : null;
    if (!picker) return;
    var input = picker.querySelector('[data-bz-tile-qty-input]');
    if (!input) return;
    var hint = picker.querySelector('[data-bz-tile-qty-hint]');
    var info = tileQtyInfoFromInput(input);
    var cartQty = cartQuantityForVariant(cart, info.variantId);
    applyTileQtyLimit(input, hint, info, cartQty);
    if (toggle.dataset && toggle.dataset.bzMode === 'add') renderLockedToggle(toggle);
  }

  function refreshAllTileQtyFromCart(cart) {
    var inputs = document.querySelectorAll('[data-bz-tile-qty-input]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      var picker = input.closest && input.closest('[data-bz-variant-picker]');
      if (!picker) continue;
      var toggle = picker.querySelector('[data-bz-variant-toggle]');
      var hint = picker.querySelector('[data-bz-tile-qty-hint]');
      var info = tileQtyInfoFromInput(input);
      var cartQty = cartQuantityForVariant(cart, info.variantId);
      applyTileQtyLimit(input, hint, info, cartQty);
      if (toggle && toggle.dataset && toggle.dataset.bzMode === 'add') renderLockedToggle(toggle);
    }
  }

  var tileQtyRefreshTimer = null;
  function refreshAllTileQtyFromLiveCart() {
    if (tileQtyRefreshTimer) clearTimeout(tileQtyRefreshTimer);
    tileQtyRefreshTimer = setTimeout(function () {
      tileQtyRefreshTimer = null;
      if (!document.querySelector('[data-bz-tile-qty-input]')) return;
      fetchCart()
        .then(function (cart) {
          refreshAllTileQtyFromCart(cart || {});
          if (cart && typeof cart.item_count === 'number') updateBubbleCounts(cart.item_count);
        })
        .catch(function () { /* keep current controls if cart cannot be read */ });
    }, 80);
  }

  function syncTileQtyLimit(picker, toggle, input, hint, info) {
    var variantId = toggle.getAttribute('data-bz-variant-id') || '';
    input.setAttribute('data-bz-variant-id', variantId);
    input.setAttribute('data-bz-tracked', info.tracked ? '1' : '0');
    input.setAttribute('data-bz-stock', String(info.stock || 0));
    input.setAttribute('data-bz-can-backorder', info.canBackorder ? '1' : '0');
    applyTileQtyLimit(input, hint, tileQtyInfoFromInput(input), 0);
    if (!info.tracked || info.canBackorder || !variantId) return;

    var token = String(Date.now()) + '-' + Math.random();
    picker.setAttribute('data-bz-qty-token', token);
    fetchCart()
      .then(function (cart) {
        if (picker.getAttribute('data-bz-qty-token') !== token) return;
        if (cart && typeof cart.item_count === 'number') updateBubbleCounts(cart.item_count);
        var sig = cartSig(cart);
        if (sig === null || sig !== lastCartSig) {
          dispatchCartUpdate(cart || {}, toggle.id || '', { source: 'bz-cart-sync', variantId: variantId });
        }
        refreshTileQtyFromCart(toggle, cart);
      })
      .catch(function () { /* keep the stock-only max if cart sync fails */ });
  }

  function formatMoney(cents) {
    var fmt = window.__bzMoneyFormat || '${{amount}}';
    cents = Math.round(cents || 0);
    function withDelimiters(decimals, thousands, decimal) {
      var fixed = (cents / 100).toFixed(decimals);
      var parts = fixed.split('.');
      var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return decimals ? intPart + decimal + parts[1] : intPart;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(2, ' ', '.');
        case 'amount_no_decimals_with_space_separator': return withDelimiters(0, ' ', '.');
        default: return '';
      }
    });
  }

  function renderLockedToggle(toggle) {
    var unit = parseInt(toggle.getAttribute('data-bz-unit-cents'), 10);
    var fullTitle = toggle.getAttribute('data-bz-variant-title') || '';
    var vtitle = fullTitle;
    var qty = 1;
    var blockedLabel = '';
    var picker = toggle.closest('[data-bz-variant-picker]');
    if (picker) {
      var input = picker.querySelector('[data-bz-tile-qty-input]');
      if (input) {
        var max = parseInt(input.getAttribute('max'), 10);
        if (!isNaN(max) && max < 1) {
          blockedLabel = input.getAttribute('data-bz-cart-limit') ? 'Cart limit reached' : 'Max reached';
          qty = 0;
        }
        var q = parseInt(input.value, 10);
        if (!blockedLabel && q && q > 0) qty = q;
      }
    }

    // The button carries only the part of the variant title the chips are not already
    // showing, so the card never says the same thing twice.
    //
    // Inline chips print the size token and the price, and drop everything after the
    // first bracket -- so `3-4" (Adult WC)` shows as `3-4"`. What the bracket holds is
    // life stage and sex, which for a live animal is not a footnote: adult versus 2nd
    // instar changes what the keeper is buying and how they have to house it. That is
    // what the button says.
    //
    // Two cases need nothing added. When two variants reduce to the same token the tile
    // falls back to full titles on the chips (chip mode `full`), so the bracket is
    // already on screen. And a title with no bracket at all is printed whole by the chip.
    // Either way the button drops to `Add · $39.99` on its own.
    //
    // Dropdown pickers (bz-featured-slide) close after a pick, taking the sizes with
    // them, so there the whole title stays on the button as the only confirmation.
    if (picker && picker.hasAttribute('data-bz-variant-inline')) {
      if (picker.getAttribute('data-bz-chip-mode') === 'full') {
        vtitle = '';
      } else {
        var bracketed = vtitle.match(/\(([^)]*)\)/);
        vtitle = bracketed ? bracketed[1].trim() : '';
      }
    }

    var totalPriceLabel;
    if (blockedLabel) {
      totalPriceLabel = blockedLabel;
      vtitle = '';
    } else if (!isNaN(unit)) {
      totalPriceLabel = formatMoney(unit * qty);
    } else {
      totalPriceLabel = toggle.getAttribute('data-bz-variant-price') || '';
    }
    var actionLabel = blockedLabel
      ? totalPriceLabel
      : 'Add &middot; ' + (vtitle ? vtitle + ' · ' : '') + totalPriceLabel;
    var lockedHtml =
      '<span class="bz-tile__add-label">' +
        '<span aria-hidden="true">＋</span> ' + actionLabel +
      '</span>' +
      '<span class="bz-tile__add-change" data-bz-change role="button" aria-label="Change size" title="Change size">▾</span>';
    // 2026-10-25: while "Added" is flashing, park the fresh label for when the flash ends instead of
    // cutting the flash short (and then having it restore the old label).
    if (toggle.classList.contains('is-flashed')) toggle.setAttribute('data-prev-html', lockedHtml);
    else toggle.innerHTML = lockedHtml;

    // The visible label is deliberately shorter than the variant title now, so pin the
    // accessible name to the whole thing -- a screen reader still gets the size, the
    // stage and the price. When the button is blocked it says why, and that is the
    // accessible name too.
    if (blockedLabel || !fullTitle) {
      toggle.removeAttribute('aria-label');
    } else {
      toggle.setAttribute('aria-label', 'Add ' + fullTitle + ' · ' + totalPriceLabel + ' to cart');
    }
  }

  // Update the small "Only N left" stock line on the surrounding tile when a
  // different variant is picked, so it matches the picked variant rather than
  // staying on the default-variant snapshot. Applies to bz-product-tile (the
  // stock pill lives there); bz-featured-slide has no equivalent line and is
  // skipped silently when the element isn't found.
  function updateTileStockLine(picker, info) {
    var tile = picker.closest('.bz-tile');
    if (!tile) return;
    var stockEl = tile.querySelector('.bz-tile__stock');
    if (!stockEl) return;
    var state = '';
    var qty = info.stock || 0;
    if (!info.tracked) {
      state = 'in';
    } else if (qty > 5) {
      state = 'in';
    } else if (qty > 0) {
      state = 'low';
    } else if (info.canBackorder) {
      state = 'backorder';
    } else {
      state = 'out';
    }
    stockEl.setAttribute('data-state', state);
    var label;
    switch (state) {
      case 'in':        label = 'In stock'; break;
      case 'low':       label = 'Only ' + qty + ' left'; break;
      case 'backorder': label = 'Backorder'; break;
      case 'out':       label = 'Sold out'; break;
      default:          label = 'In stock';
    }
    var dot = stockEl.querySelector('.bz-tile__stock-dot');
    stockEl.textContent = '';
    if (dot) stockEl.appendChild(dot); else {
      var d = document.createElement('span');
      d.className = 'bz-tile__stock-dot';
      d.setAttribute('aria-hidden', 'true');
      stockEl.appendChild(d);
    }
    stockEl.appendChild(document.createTextNode(label));
  }

  // Point the card photo at the picked size. Shopify variant images are drawn from the
  // product's own media, so a size either has one of this product's pictures or none --
  // and "none" restores the photo the card shipped with rather than leaving a blank frame.
  //
  // Two card shapes share the picker: bz-product-tile paints an <img>, bz-featured-slide
  // paints a CSS background. Anything else (a surface with no photo hook) is skipped.
  function applyPickedVariantImage(picker, pick) {
    var src = pick.getAttribute('data-variant-image') || '';
    var alt = pick.getAttribute('data-variant-image-alt') || '';
    var focal = pick.getAttribute('data-variant-image-focal') || '';

    var tile = picker.closest('.bz-tile');
    var img = tile && tile.querySelector('[data-bz-tile-image]');
    if (img) {
      swapTileImage(img, src, alt, focal);
      return;
    }

    var slide = picker.closest('.exotic-slide');
    var photo = slide && slide.querySelector('[data-bz-slide-photo]');
    if (photo) swapSlidePhoto(photo, src, focal);
  }

  function applyTileImageAttrs(img, src, alt, focal) {
    if (src) img.setAttribute('src', src);
    // A srcset would outrank the src we just set. The tile ships a plain src today; drop
    // any srcset defensively so this keeps working if the markup gains one later.
    if (img.hasAttribute('srcset')) img.removeAttribute('srcset');
    if (alt) img.setAttribute('alt', alt);
    img.style.objectPosition = focal || '';
  }

  // Fetch a size's photo before anyone asks for it, and hand back the same loader on every
  // later call for that URL. This is what makes the FIRST pick as quick as the rest: without
  // it, tapping a size started the download, so the card sat on the old picture for as long
  // as the network took. Warming happens as the card scrolls into view (see warmPickerImages),
  // by which point the file is decoded and the swap is a repaint, not a request.
  var warmedImages = Object.create(null);

  function warmImage(src) {
    if (!src) return null;
    if (warmedImages[src]) return warmedImages[src];
    var loader = new Image();
    loader.decoding = 'async';
    // Never let a photo nobody has asked for yet outrank the tiles still painting.
    if ('fetchPriority' in loader) loader.fetchPriority = 'low';
    loader.src = src;
    warmedImages[src] = loader;
    return loader;
  }

  function imageReady(loader) {
    return !!(loader && loader.complete && loader.naturalWidth > 0);
  }

  // Both swaps below can be waiting on a download at once when someone runs along the chips
  // (2" -> 4" -> back to 2"). Stamp each element with the latest request and let stale
  // callbacks drop out, otherwise the slowest download wins and the card settles on a size
  // the customer already moved off.
  var swapRequestCounter = 0;

  function swapTileImage(img, src, alt, focal) {
    var nextSrc = src || img.getAttribute('data-bz-default-src') || '';
    var nextAlt = src ? alt : (img.getAttribute('data-bz-default-alt') || '');
    var nextFocal = src ? focal : (img.getAttribute('data-bz-default-focal') || '');
    if (!nextSrc) return;

    var token = ++swapRequestCounter;
    img._bzSwapToken = token;

    // Same picture, different crop or alt: settle those without touching src.
    if (nextSrc === img.getAttribute('src')) {
      applyTileImageAttrs(img, '', nextAlt, nextFocal);
      return;
    }

    // Warmed and decoded is the normal case, so swap in the same tick. Only a photo that
    // somehow is not ready yet waits, and it waits on the download alone -- no animation
    // is allowed to add time to a picture change.
    var loader = warmImage(nextSrc);
    if (imageReady(loader)) {
      applyTileImageAttrs(img, nextSrc, nextAlt, nextFocal);
      return;
    }
    loader.addEventListener('load', function () {
      if (img._bzSwapToken !== token) return;
      applyTileImageAttrs(img, nextSrc, nextAlt, nextFocal);
    }, { once: true });
  }

  function swapSlidePhoto(photo, src, focal) {
    var nextSrc = src || photo.getAttribute('data-bz-default-photo') || '';
    var nextFocal = (src ? focal : photo.getAttribute('data-bz-default-focal')) || '50% 50%';
    if (!nextSrc) return;

    var token = ++swapRequestCounter;
    photo._bzSwapToken = token;

    var paint = function () {
      if (photo._bzSwapToken !== token) return;
      photo.style.setProperty('--photo', "url('" + nextSrc + "')");
      photo.style.backgroundPosition = nextFocal;
    };

    var loader = warmImage(nextSrc);
    if (imageReady(loader)) paint();
    else loader.addEventListener('load', paint, { once: true });
  }

  // Warm only the photo a shopper is actually approaching. The old IntersectionObserver
  // fetched every variant photo on every nearby card, so a collection page could spend
  // megabytes on images nobody selected while its visible grid was still loading.
  function scheduleImageWarming(picker) {
    var picks = picker.querySelectorAll('[data-bz-variant-pick][data-variant-image]');
    for (var i = 0; i < picks.length; i++) {
      (function (pick) {
        var warmPick = function () { warmImage(pick.getAttribute('data-variant-image')); };
        pick.addEventListener('pointerenter', warmPick, { once: true });
        pick.addEventListener('focus', warmPick, { once: true });
        pick.addEventListener('touchstart', warmPick, { once: true, passive: true });
      })(picks[i]);
    }
  }

  function ensureQtyStepper(picker, toggle, info) {
    var stepper = picker.querySelector('[data-bz-tile-qty]');
    if (!stepper) {
      stepper = document.createElement('div');
      stepper.className = 'bz-tile__qty';
      stepper.setAttribute('data-bz-tile-qty', '');
      stepper.innerHTML =
        '<button type="button" class="bz-tile__qty-btn" data-bz-tile-qty-step="-1" aria-label="Decrease quantity">−</button>' +
        '<input class="bz-tile__qty-input" data-bz-tile-qty-input type="number" inputmode="numeric" pattern="[0-9]*" min="1" value="1" aria-label="Quantity">' +
        '<button type="button" class="bz-tile__qty-btn" data-bz-tile-qty-step="1" aria-label="Increase quantity">+</button>' +
        '<span class="bz-tile__qty-hint" data-bz-tile-qty-hint></span>';
      // Place the stepper immediately after the toggle button.
      if (toggle.nextSibling) {
        picker.insertBefore(stepper, toggle.nextSibling);
      } else {
        picker.appendChild(stepper);
      }
      bindTileQtyStepper(stepper);
    }

    var input = stepper.querySelector('[data-bz-tile-qty-input]');
    var hint = stepper.querySelector('[data-bz-tile-qty-hint]');
    syncTileQtyLimit(picker, toggle, input, hint, info);
  }

  function bindTileQtyStepper(stepper) {
    var input = stepper.querySelector('[data-bz-tile-qty-input]');
    var btns = stepper.querySelectorAll('[data-bz-tile-qty-step]');
    var picker = stepper.closest('[data-bz-variant-picker]');
    var toggle = picker ? picker.querySelector('[data-bz-variant-toggle]') : null;
    function getMax() {
      var m = parseInt(input.getAttribute('max'), 10);
      return isNaN(m) ? null : m;
    }
    function refreshToggle() {
      if (toggle && toggle.dataset.bzMode === 'add') renderLockedToggle(toggle);
    }
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var step = parseInt(b.getAttribute('data-bz-tile-qty-step'), 10) || 1;
          var v = (parseInt(input.value, 10) || 1) + step;
          input.value = String(clamp(v, 1, getMax()));
          refreshToggle();
        });
      })(btns[i]);
    }
    // Picker lives inside the product tile (which has a .bz-tile__link overlay).
    // Stop the bubble + prevent the default so the input can be focused/typed in.
    input.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    input.addEventListener('click', function (e) {
      e.stopPropagation();
      e.preventDefault();
      input.focus();
    });
    input.addEventListener('keydown', function (e) { e.stopPropagation(); });
    input.addEventListener('input', refreshToggle);
    input.addEventListener('change', function () {
      var v = parseInt(input.value, 10);
      if (!v || v < 1) v = 1;
      input.value = String(clamp(v, 1, getMax()));
      refreshToggle();
    });
  }

  function bindVariantPickers(root) {
    var pickers = (root || document).querySelectorAll('[data-bz-variant-picker]');
    for (var i = 0; i < pickers.length; i++) {
      (function (picker) {
        if (picker.dataset.bzPickerBound) return;
        picker.dataset.bzPickerBound = '1';

        var toggle = picker.querySelector('[data-bz-variant-toggle]');
        var list = picker.querySelector('.bz-tile__variant-list');
        if (!toggle || !list) return;

        // Inline picker (bz-product-tile): sizes render as chips on the card, so the list
        // is never hidden, never portaled, and the toggle exists only as the post-pick Add
        // button. Liquid ships it unhidden; this is belt and braces.
        var inline = picker.hasAttribute('data-bz-variant-inline');
        if (inline) list.removeAttribute('hidden');

        scheduleImageWarming(picker);

        toggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          if (toggle.dataset.bzMode === 'add') {
            // If they tapped the small change chevron, reopen the picker instead of adding.
            // Inline pickers have no chevron -- the chips never went away, you just tap a
            // different one -- so any click on the button adds.
            if (!inline && e.target.closest('[data-bz-change]')) {
              openPicker(picker, toggle, list);
              return;
            }
            add(toggle);
            return;
          }

          // Nothing to open on an inline picker.
          if (inline) return;

          var open = !list.hasAttribute('hidden');
          if (open) {
            closePicker(toggle, list);
          } else {
            openPicker(picker, toggle, list);
          }
        });

        function selectVariant(pick, moveFocus) {
          if (pick.disabled) return;
          var vid = pick.getAttribute('data-variant-id');
          var vtitle = pick.getAttribute('data-variant-title') || '';
          var vprice = pick.getAttribute('data-variant-price') || '';
          var vcents = parseInt(pick.getAttribute('data-variant-price-cents'), 10);
          var tracked = pick.getAttribute('data-variant-tracked') === '1';
          var stock = parseInt(pick.getAttribute('data-variant-stock'), 10);
          if (isNaN(stock)) stock = 0;
          var policy = pick.getAttribute('data-variant-policy') || '';
          var canBackorder = policy === 'continue';

          toggle.dataset.bzMode = 'add';
          toggle.setAttribute('data-bz-variant-id', vid);
          // 2026-10-25 speed: warm the guard's live-stock read for this fella now, so the Add tap
          // that usually follows doesn't wait on it (the guard keeps it for 15 s).
          if (window.bzInventoryGuard && window.bzInventoryGuard.prefetch) {
            window.bzInventoryGuard.prefetch(buttonHandle(toggle));
          }
          toggle.setAttribute('data-bz-variant-title', vtitle);
          toggle.setAttribute('data-bz-variant-price', vprice);
          if (!isNaN(vcents)) toggle.setAttribute('data-bz-unit-cents', vcents);
          else toggle.removeAttribute('data-bz-unit-cents');
          toggle.classList.remove('bz-tile__add--choose');
          toggle.classList.add('is-locked');
          if (!inline) {
            toggle.setAttribute('aria-expanded', 'false');
            closePortal(list);
            list.setAttribute('hidden', '');
          }

          // Mark the selection. Dropdown surfaces (bz-featured-slide) use the
          // listbox contract; inline chips are plain toggle buttons and use
          // aria-pressed, so handle whichever this picker actually renders.
          var items = picker.querySelectorAll('[role="option"]');
          for (var k = 0; k < items.length; k++) items[k].setAttribute('aria-selected', 'false');
          var li = pick.closest('[role="option"]');
          if (li) li.setAttribute('aria-selected', 'true');

          var chips = picker.querySelectorAll('[data-bz-variant-pick][aria-pressed]');
          for (var m = 0; m < chips.length; m++) chips[m].setAttribute('aria-pressed', 'false');
          if (pick.hasAttribute('aria-pressed')) pick.setAttribute('aria-pressed', 'true');

          ensureQtyStepper(picker, toggle, {
            tracked: tracked,
            stock: stock,
            canBackorder: canBackorder
          });

          updateTileStockLine(picker, {
            tracked: tracked,
            stock: stock,
            canBackorder: canBackorder
          });

          applyPickedVariantImage(picker, pick);

          renderLockedToggle(toggle);

          if (moveFocus) toggle.focus();
        }

        var picks = picker.querySelectorAll('[data-bz-variant-pick]');
        for (var j = 0; j < picks.length; j++) {
          (function (pick) {
            pick.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              selectVariant(pick, true);
            });
          })(picks[j]);
        }

        // Substrate cards start with the first available catalog size.
        // Initial selection updates the card without taking keyboard focus.
        if (inline && picker.hasAttribute('data-bz-variant-default-first')) {
          for (var n = 0; n < picks.length; n++) {
            if (picks[n].disabled) continue;
            selectVariant(picks[n], false);
            break;
          }
        }
      })(pickers[i]);
    }
  }

  if (!window.__bzPickerGlobals) {
    window.__bzPickerGlobals = true;
    document.addEventListener('cart:update', function (event) {
      var detail = event && event.detail ? event.detail : {};
      var source = detail.data && detail.data.source;
      var heard = cartSig(detail.resource);
      if (heard !== null) lastCartSig = heard;
      if (source === 'bz-cart-sync') return;
      if (detail.resource && detail.resource.items) {
        refreshAllTileQtyFromCart(detail.resource);
        if (typeof detail.resource.item_count === 'number') updateBubbleCounts(detail.resource.item_count);
      } else {
        refreshAllTileQtyFromLiveCart();
      }
    });
    window.addEventListener('focus', refreshAllTileQtyFromLiveCart);
    window.addEventListener('pageshow', refreshAllTileQtyFromLiveCart);
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refreshAllTileQtyFromLiveCart();
    });
    document.addEventListener('click', function (e) {
      // Click inside a picker, the toggle, OR a portaled list: keep open
      if (
        e.target.closest('[data-bz-variant-picker]') ||
        e.target.closest('.bz-tile__variant-list--portal')
      ) return;
      closeAllPickers(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAllPickers(null);
    });
  }

  window.bzCartAdd = {
    bind: bind,
    fetchCartCount: fetchCartCount,
    addItems: addItems,
    clearCart: clearCart,
    formatMoney: formatMoney,
    cartLimitForVariant: cartLimitForVariant
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }
})();
